<div class="start-row-container row-gap-0p5">
  <app-overlay-pop-up [matchTriggerWidth]="false" [closeOnInsideClick]="false" [blockRepositioning]="true">
    <div overlay-trigger class="centered-column-container control-shrinked-container">
      <div
        data-qa="org-overview-show-funds-selector"
        class="space-between-horizontal-centered control clickable min-width-12">
        <span class="caption-2 bold500">{{selectedFundsAmount.all}} of {{fundsData.all.length}} fund{{fundsData.all.length !== 1 ? 's' : ''}} selected</span>
        <app-all-icons
          [iconNameAndStyling]="'arrow-down.svg;icon-size-1p25'">
        </app-all-icons>
      </div>
    </div>
    <div overlay-content>
      <div
        *ngIf="fundsData.all.length else emptyState"
        class="overlay-dropdown start-column-container">
        <div class="overlay-list">
          <div class="list-block">
            <div class="start-row-container list-entry" (click)="toggleAllFunds()">
              <app-checkbox
                [attr.data-qa]="'org-overview-checkbox-select-all'"
                [checked]="selectedFundsAmount.all === fundsData.all.length"
                (checkBoxClicked)="toggleAllFunds()">
              </app-checkbox>
              <span>Select all</span>
            </div>
            <ng-container *ngFor="let group of shownGroups">
              <div *ngIf="fundsData[group].length">
                <span class="list-subheader"> {{group === 'funds' ? 'Funds' : 'SPVs'}} </span>
                <div *ngFor="let fund of fundsData[group]" class="start-row-container list-entry" (click)="toggleFund(fund)">
                  <app-checkbox
                    [attr.data-qa]="'org-overview-checkbox-selector' + fund.name"
                    [checked]="fund.isShown"
                    (checkBoxClicked)="toggleFund(fund)">
                  </app-checkbox>
                  <span>{{fund.name}}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <ng-template #emptyState>
        <span class="list-subheader">No funds</span>
      </ng-template>
    </div>
  </app-overlay-pop-up>
</div>
